module.exports = __webpack_public_path__ + "img/avartar.4e594cf8.png";